<template>
	<div class="xs-12">
		<div class="block">
			<!-- Label -->
			<label :for="name" class="xs-12 fs4 fw7 lh125">
				{{ label }}
				<slot name="label"></slot>
			</label>
		</div>

		<!-- Component for input -->
		<component
			v-if="isBeingEdited || ignoreInlineView(componentName)"
			:is="componentName"
			:id="name"
			:name="name"
			:size="size"
			:value="value"
			v-bind="{ ...$props, ...$attrs }"
			v-on="$listeners"
			@blur="disableIsBeingEdited()"
			ref="field"
		/>

		<!-- Value as text -->
		<div
			class="cu2 lh125 value pt1 pb1"
			@click="onValueClick"
			v-if="!isBeingEdited && !ignoreInlineView(componentName)"
		>
			<!-- We list all options so taht we handle properly booleans false and 0 displaying -->
			{{ computedValue }}
		</div>
	</div>
</template>

<script>
import JBaseInputText from "@/components/JBaseInputText"
import JBaseInputLongText from "@/components/JBaseInputLongText"
import JBaseToggle from "@/components/JBaseToggle"
import InputCategoriesList from "./InputCategoriesList"

// List of components that will be displayed directly as it is
const ignoreInlineViewComponents = ["j-base-toggle", "input-categories-list"]

export default {
	components: {
		JBaseInputText,
		InputCategoriesList,
		JBaseInputLongText,
		JBaseToggle
	},

	props: {
		/**
		 * Important for validation and label, has to be unique in one form
		 */
		name: { type: String, required: true },
		/**
		 * It is either string e.g. j-base-input-text
		 * When it is an object, it is a component object
		 */
		componentName: {
			type: [String, Object],
			required: true
		},
		value: {
			required: true
		},
		label: {
			type: String
		},
		/**
		 * Size of input component xsmall, small, normal, large, xlarge, null
		 */
		size: {
			validator(val) {
				return val === null || typeof val === "string"
			}
		}
	},

	data() {
		return {
			isBeingEdited: false
		}
	},

	computed: {
		computedValue() {
			return this.value !== null &&
				this.value !== undefined &&
				this.value !== ""
				? this.value
				: "---"
		}
	},

	methods: {
		// For these components we ignore displaying inline view
		// It's e.g. select product component
		// TODO: should be computed
		ignoreInlineView(componentName) {
			if (!componentName || typeof componentName !== "string") return true // when we are passing schema of the component directly, no name
			if (ignoreInlineViewComponents.includes(componentName)) return true
			return false
		},

		onValueClick() {
			this.isBeingEdited = true

			// Once component is mounted do autofocus
			this.$nextTick(() => {
				// Do autofocus on possible nested elements
				this.$refs?.field?.$el?.focus()
				this.$refs?.field?.$el?.children?.[0]?.focus()
			})
		},

		disableIsBeingEdited() {
			setTimeout(() => (this.isBeingEdited = false), 0)
		}
	}
}
</script>

<style>
.value:hover {
	background: rgba(0, 0, 0, 0.06);
}
</style>
